import { Line } from "components/DetailsSection";
import { WorkType } from "generated/types/types";
import type { TFunction } from "i18next";

const WorkTypeKey = {
  [WorkType.Service]: "work_helper_service",
  [WorkType.Mot]: "work_helper_mot",
  [WorkType.Tyres]: "work_helper_tyre", 
  [WorkType.RepairOther]: "work_helper_repair"
} as const satisfies Partial<Record<WorkType, string>>;

export const convertWorkRequiredToLines = (
  workRequired: WorkType[] = [],
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  repairOtherText: string = "",
  t: TFunction
): Line[] => {
  const lines: Line[] = [];

  for (const wt of workRequired) {
    lines.push({ text: t(WorkTypeKey[wt]) });
    if (wt === WorkType.RepairOther) {
      const extra = repairOtherText.trim();
      if (extra) lines.push({ text: extra });
    }
  }

  return lines;
};
